import { FC } from 'react'
import { IManualSuscriptionFund } from '../../../../common/interfaces'

interface IProps {
  funds: IManualSuscriptionFund[]
  value: number | ''
  onChange: (fundId: number | '') => void
  loading?: boolean
}

export const FundSelect: FC<IProps> = ({ funds, value, onChange, loading }) => (
  <div className='col-lg-6 mb-7'>
    <label htmlFor='fund' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
      Fondo
      {loading && <span className='spinner-border spinner-border-sm text-primary' role='status' />}
    </label>
    <select
      id='fund'
      className='selectForm contract-select-toggle'
      value={value}
      disabled={loading}
      onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
    >
      <option value=''>Seleccione</option>
      {funds.map((fund) => (
        <option key={fund.id} value={fund.id}>
          {fund.title}
        </option>
      ))}
    </select>
  </div>
)
